import { getEnvironmentVariable } from './environment/environment-service';

const isAdmin = groups => groups && groups.length && groups.indexOf(getEnvironmentVariable('REACT_APP_SFW_INTERNAL_GROUP')) !== -1;

export default isAdmin;
